import classNames from 'classnames';
import type { RadioSize, RadioState } from './Radio.types';

const baseInteractivityClassName =
  'focus-visible:outline-none focus-visible:ring hover:bg-state-hover';
const markerClassName =
  'relative after:content-empty after:absolute after:inset-0 after:rounded-full after:block after:m-auto';

const stateClassName: { [Key in RadioState]: string } = {
  checked: `${baseInteractivityClassName} ${markerClassName} border-shade-10 text-element-on-secondary bg-element-secondary after:bg-default`,
  unchecked: `${baseInteractivityClassName} border-default bg-default`,
};

const baseDisabledClassName =
  'border-status-disabled-dark text-status-disabled-dark bg-status-disabled';

const disabledClassName: { [Key in RadioState]: string } = {
  checked: `${baseDisabledClassName} ${markerClassName} after:bg-status-disabled-dark`,
  unchecked: baseDisabledClassName,
};

const errorClassName: { [Key in RadioState]: string } = {
  checked: `${baseInteractivityClassName} ${markerClassName} border-shade-10 text-status-on-error bg-status-error after:bg-default`,
  unchecked: `${baseInteractivityClassName} border-status-error bg-default`,
};

const sizeClassName: { [Key in RadioSize]: string } = {
  small: 'text-xs w-4 h-4',
  default: 'text-sm w-5 h-5',
  large: 'text-md w-6 h-6',
};

const markerSizeClassName: { [Key in RadioSize]: string } = {
  small: 'after:w-2 after:h-2',
  default: 'after:w-2 after:h-2',
  large: 'after:w-3 after:h-3',
};

export const getRadioClassNames = (
  state: RadioState,
  size: RadioSize,
  disabled?: boolean,
  hasError?: boolean,
  className?: string,
): string =>
  classNames(
    className,
    'flex justify-center items-center rounded-full border border-solid',
    disabled
      ? disabledClassName[state]
      : hasError
        ? errorClassName[state]
        : stateClassName[state],
    sizeClassName[size],
    markerSizeClassName[size],
  );
